// Mirrors the backend roles in

export const BASE_USER = "base_user";
export const SERVICE_USER = "service_user";
export const REPORTING_USER = "reporting_user";
export const ADMIN = "admin";
export const MSP_USER = "msp_user";

export const VIEW_ALL_CASES_ROLES = [SERVICE_USER, REPORTING_USER, ADMIN, MSP_USER];

export function roleForSpace(roles, space) {
  if (!roles || typeof roles !== "object") {
    return BASE_USER;
  }
  return roles[space] || BASE_USER;
}
